module.exports = __webpack_public_path__ + "static/media/icon_intuitive_healing.b199193c.svg";